export const config = {
    chainId: 369,
    contractAddress: "0x32CaaF879a192d7604237F223995F173e4cdc050",
    scanLink:
      "https://scan.pulsechain.com/address/0x32CaaF879a192d7604237F223995F173e4cdc050",
  };
  